import httpHelper from "@/helpers/httpHelper";
// action types
export const GET_WALLETS = "getWallets";

// mutation types
export const SET_WALLETS = "setWallets";


export default {
    state: {
        wallets: [],
       
    },
    getters: {
        /**
         * Get list of detailsSharing for current page
         * @param state
         * @returns {*}
         */
        loadedWallets(state) {
            return state.wallets;
        },

    },
    actions: {
        /**
         * Set the detailsSharing list
         * @param state
         * @param payload
         */
        [GET_WALLETS](state, payload) {
            
            httpHelper
                .getData(payload)
                .then((response) => {
                    state.commit(SET_WALLETS, response.result);
                    
                })
                .catch((error) => {})
                .finally(() => {});
            
        },
       
    },
    mutations: {
        // [SET_DETAILS_SHARING](state, payload) {
        //     state.detailsSharing = [...state.detailsSharing, payload];
        // },
        [SET_WALLETS](state, payload) {
            state.wallets = payload;
        },
       
    }
};